'use strict';

const $window   = $(window);
const $document = $(document);
const $body     = $('body');

let wW          = $window.outerWidth();
let wH          = $window.outerHeight();
let dH          = $document.outerHeight();

$document.on('preloaded.after', function () {
    $window
        .on('scroll', function () {
            Animator.onScroll();

            if (typeof Navigation !== 'undefined') { Navigation.onScroll(); }
        })
        .trigger('scroll');
});

$document.on('preloaded.before', function () {
    $window
        .on('resize', function () {
            wW = $window.outerWidth();
            wH = $window.outerHeight();
            dH = $document.outerHeight();
        });

    Component.init();

    if (typeof Navigation !== 'undefined') { Navigation.init(); }

    $('img[data-src]').lazyload({ data_attribute: 'src', effect : 'fadeIn' });

    // Add your code here

    $document.on('click', '.icon-save', function(e){
        const $this = $(this);
        const url = $this.attr('href');
        e.preventDefault();

        if($this.hasClass('sending')){
            return;
        }

        $this.hasClass('sending');

        $.ajax({
            method: "get",
            url: url
        }).done(function(data) {
            if(data.status){
                $this.addClass('active');

                $('[data-component="modal-download-center"]').trigger('file:add', [data]);
            } else {
                //alert('erro');
            }
        }).fail(function() {
            //alert('erro 500');
        }).always(function(){
            $this.removeClass('sending');
        });
    });

    $window.trigger('resize').trigger('popstate');
});

$body.waitForImages(true)
    .progress((loaded, count, success) => {
        count++;

        let percent = (loaded * 100 / count);

        TweenLite.to('.preloader__bar__progress', .4, { width: percent+'%', ease: Power2.easeInOut });
    })
    .done(() => {
        TweenLite.to('.preloader__bar__progress', .3, { width: '100%', onComplete: () => {
            $document.trigger('preloaded.before');

            TweenLite.to('.preloader', .2, { opacity: 0, display: 'none', ease: Linear.easeNone, onComplete: () => $document.trigger('preloaded.after') });
        } });
    });


window.loading = {
    show: function(btnCancelUpload){
        let modalHtml = `<div class="modal-loading">
                            <div class="modal-container">
                                <div class="modal-center-box">
                                    <div class="box">
                                    <div class="loadingio-spinner-rolling-i6g53c7alg"><div class="ldio-pfwq6h8ujd"><div></div></div></div>
                                    </div>
                                </div>
                            </div>
                        </div>`;


        $('body').append(modalHtml);
        $('.modal-loading').show();
        setTimeout(function(){
            $('.modal-loading').addClass('opened');
        },200)
    },
    hide: function(){
        $('.modal-loading').removeClass('opened');
        setTimeout(function(){
            $('.modal-loading').remove();
        },400)
    }
}

function download_files(files) {
    function download_next(i) {
        if (i >= files.length) {
            return;
        }
        var a = document.createElement('a');
        a.href = files[i].download;
        a.target = '_parent';
        // Use a.download if available, it prevents plugins from opening.
        if ('download' in a) {
            a.download = files[i].filename;
        }
        // Add a to the doc for click to work.
        (document.body || document.documentElement).appendChild(a);
        if (a.click) {
            a.click(); // The click method is supported by most browsers.
        } else {
            $(a).click(); // Backup using jquery
        }
        // Delete the temporary link.
        a.parentNode.removeChild(a);
        // Download the next file with a small timeout. The timeout is necessary
        // for IE, which will otherwise only download the first file.
        setTimeout(function() {
            download_next(i + 1);
        }, 500);
    }
    // Initiate the first download.
    download_next(0);
}
